"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isString_1 = __importDefault(require("lodash/isString"));
function isValidPath(path) {
    return (0, isString_1.default)(path) && !path.includes('*');
    // console.log(path, isString(path) && /^(\/[a-z0-9~\\\-%^|"\ _]*)+$/gi.test(path))
    // return isString(path) && /^(\/[a-z0-9~\\\-%^|"\ _]*)+$/gi.test(path);
}
exports.default = isValidPath;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNWYWxpZFBhdGguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZm4vaXNWYWxpZFBhdGgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSw2REFBdUM7QUFFdkMsU0FBUyxXQUFXLENBQUMsSUFBSTtJQUN2QixPQUFPLElBQUEsa0JBQVEsRUFBQyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLENBQUE7SUFDNUMsbUZBQW1GO0lBQ25GLHdFQUF3RTtBQUMxRSxDQUFDO0FBRUQsa0JBQWUsV0FBVyxDQUFDIn0=